import {
  DateTimeField,
  NumberField,
  RelationshipField,
  RelationshipFieldMany,
  StringField,
  LongTextField,
} from "../plugins/Cruxtify/field-types";
import {
  DateTimeProperty,
  NumberProperty,
  RelationshipProperty,
  RelationshipPropertyMany,
  StringProperty,
} from "../plugins/Cruxtify/property-types";
import {
  UserPermission,
  UserPermissions,
  UserRole,
} from "../plugins/Cruxtify/UserPermission";
import { ApcCrudModel } from "./ApcCrudModel";

export class QuoteRequest extends ApcCrudModel {
  public static icon = "mdi-file-document-outline";
  protected static _typeLabel = "Quote Request";
  protected static asProperty = "quote_request";
  public static api = {
    path: "quote-requests",
  };

  protected userIdField = ["user"];
  protected static routeBase = "quote-requests";

  protected static userPermissions = new UserPermissions(
    {},
    UserPermission.Read
  );

  protected static propertyDefinitions = [
    {
      type: NumberProperty,
      opts: {
        name: "id",
        label: "ID",
        userPermissions: UserPermission.Hidden,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "created_at",
        label: "Created At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: DateTimeProperty,
      opts: {
        name: "updated_at",
        label: "Updated At",
        userPermissions: UserPermission.Read,
        computed: true,
      },
    },
    {
      type: RelationshipProperty,
      opts: {
        name: "user",
        label: "User",
        relatedModel: "User",
        foreignProperty: "quote_requests",
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "customer_notes",
        label: "Customer Notes",
      },
    },
    {
      type: StringProperty,
      opts: {
        name: "additional_information",
        label: "Additional Information",
      },
    },
    {
      type: RelationshipPropertyMany,
      opts: {
        name: "configurations",
        label: "Configurations",
        relatedModel: "Configuration",
        foreignProperty: "quote_requests",
        computed: true,
      },
    },
  ];

  protected static fieldDefinitions = [
    { type: NumberField, opts: { property: "id" } },
    {
      type: DateTimeField,
      opts: { property: "created_at", isPrimaryLabelField: 2 },
    },
    { type: DateTimeField, opts: { property: "updated_at" } },
    {
      type: RelationshipField,
      opts: { property: "user", isPrimaryLabelField: 1 },
    },
    { type: LongTextField, opts: { property: "customer_notes" } },
    { type: LongTextField, opts: { property: "additional_information" } },
    {
      type: RelationshipFieldMany,
      opts: {
        property: "configurations",
        viewComponentName: "configurations-field",
      },
    },
    {
      type: RelationshipFieldMany,
      opts: {
        id: "configurations-short",
        property: "configurations",
        viewComponentName: "configurations-field-short",
      },
    },
  ];

  protected static collectionLayoutDefinitions = [
    {
      id: "table",
      columnFields: ["id", "created_at", "user", "configurations-short"],
      enableSearch: true,
      enableDynamicFilters: true,
      useModal: true,
      dynamicFilterOptions: {
        filterFields: [
          "id",
          "user",
          "customer_notes",
          "additional_information",
          "configurations",
          "created_at",
          "updated_at",
        ],
      },
      defaultSort: [
        {
          field: "created_at",
          order: "desc",
        },
      ],
    },
  ];

  protected static modelLayoutDefinitions = [
    {
      type: "FieldSetGridLayout",
      opts: {
        id: "quoteRequestDetails",
        fieldSets: [
          {
            id: "main",
            fields: ["user", "customer_notes", "additional_information"],
          },
          {
            id: "configurations",
            fields: ["configurations"],
          },
          {
            id: "meta",
            fields: ["created_at", "updated_at", "id"],
          },
        ],
      },
    },
  ];
}
